import React from "react";
import { capitalize } from "lodash";
import { Flex } from "@jsq/ds/core";
import { DetailedAchPaymentPrefObjectType } from "../../../common/types";
import PaymentDetailsModalField from "../PaymentDetailsModalField";
import { AchVisibleFields } from "../types";
import { isAchFieldVisible } from "../utils/fieldVisibility";

export type AchPaymentPrefDisplayProps = {
  achPaymentPrefFull: DetailedAchPaymentPrefObjectType;
  visibleFields?: AchVisibleFields;
};

export const AchPaymentPrefDisplay: React.FC<AchPaymentPrefDisplayProps> = ({
  achPaymentPrefFull,
  visibleFields,
}: AchPaymentPrefDisplayProps) => {
  const gap = 8; // gap between rows and columns
  return (
    <Flex gap={gap} flexDirection="column" data-testid="AchPaymentPrefDisplayFlex">
      <PaymentDetailsModalField
        label="Account holder name"
        value={achPaymentPrefFull.accountName}
        gap={gap}
        visible={isAchFieldVisible("accountName", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Bank name"
        value={achPaymentPrefFull.bankName}
        gap={gap}
        visible={isAchFieldVisible("bankName", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Routing number"
        value={achPaymentPrefFull.routingNumber}
        gap={gap}
        visible={isAchFieldVisible("routingNumber", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Account number"
        value={achPaymentPrefFull.accountNumber}
        gap={gap}
        visible={isAchFieldVisible("accountNumber", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Account type"
        value={achPaymentPrefFull.accountType && capitalize(achPaymentPrefFull.accountType)}
        gap={gap}
        visible={isAchFieldVisible("accountType", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Ownership type"
        value={
          achPaymentPrefFull.accountOwnership && capitalize(achPaymentPrefFull.accountOwnership)
        }
        gap={gap}
        visible={isAchFieldVisible("accountOwnership", visibleFields)}
      />
      {achPaymentPrefFull.additionalInstructions && (
        <PaymentDetailsModalField
          label="Additional instructions"
          value={achPaymentPrefFull.additionalInstructions}
          gap={gap}
          visible={isAchFieldVisible("additionalInstructions", visibleFields)}
        />
      )}
    </Flex>
  );
};
